/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SeedInfoDto as DemoSeedSeedInfoDto } from '../../models/demo-seed/seed-info-dto';

export interface SeedSingleEnsemble$Params {
}

export function seedSingleEnsemble(http: HttpClient, rootUrl: string, params?: SeedSingleEnsemble$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoSeedSeedInfoDto>> {
  const rb = new RequestBuilder(rootUrl, seedSingleEnsemble.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoSeedSeedInfoDto>;
    })
  );
}

seedSingleEnsemble.PATH = '/demo-seed/single-ensemble';

